import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import api from "../../api/api";
import CloseIcon from '@mui/icons-material/Close';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import EditIcon from '@mui/icons-material/Edit';
import addpdf from '../../assets/Schedule/Button.svg';
import SaveIcon from '@mui/icons-material/Save';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import { Edit } from '@mui/icons-material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import ScheduleModal from "../../tasks/Modals/ScheduleModal";
import ToastMessage from "../../utils/mui/righttoptoast";
import checkout from '../../../src/assets/Schedule/checkout.svg'
import ConfirmCheckoutModal from "./chcekoutconformmodal";
const Checkout = ({closeAllModals,selectedDate,fetchScheduleData,setIsAptcard,selectedAppointment,orderData,navigateto,setScreen }) => {
  const [editingNote, setEditingNote] = useState(null); // Track the index of the note being edited
  const [newNote, setNewNote] = useState(''); // Track the text input for new or edited note
  const [selectedTasks, setSelectedTasks] = useState([]); 
  const [selectAll, setSelectAll] = useState(false); // Track Check All checkbox state
  const [isCompleted, setIsCompleted] = useState(false); 
      const [checkoutloading,setCheckoutLoading]=useState(false)
  const practiseid = window.getPracticeId();
      const [CheckoutConformation,setCheckoutconformation]=useState(false)
  const [scheduleStates, setScheduleStates] = useState({});
  const [scheduleConfirmationOpen, setScheduleConfirmationOpen] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [isLoading, setIsLoading] = useState(false); 
  const[task,setTask]=useState([])
  let firstName = localStorage.getItem('firstname');
  let lastName = localStorage.getItem('lastname');
  const fullName = `${firstName} ${lastName}`;
 
  const [openToast, setOpenToast] = useState(false);
        const [toastMessage, setToastMessage] = useState('');
  
        const [toastSeverity, setToastSeverity] = useState('success');
    const handleToastClose = () => {
    setOpenToast(false);
  };

  const handleNoteEdit = (index) => {
    setEditingNote(index); // Set the index of the note being edited
    setNewNote(task[index].order_notes || ''); // Populate the input field with the existing note (if any)
  };

  const fetchOrderData = async ({orderStartDate}) => {
    const formattedStartDate = dayjs(orderStartDate).format('YYYY-MM-DD');
    // console.log("fStartDate",formattedStartDate);
     setIsLoading(true)
    try {
      const response = await api.post(`/v1/${practiseid}/scheduler/patients/${selectedAppointment?.patientid}/get_orders`, {
        startdate: formattedStartDate, // Payload to send in POST request
      });
      if (response.status === 200) {
        setTask(response.data); // Set the order data on success
      } else {
        setTask([]); // Clear if response is not successful
      }
    } catch (error) {
      console.error(error);
      setTask([]); // In case of error, clear the options
    } finally {
      setIsLoading(false); // Stop loading
    }
  };

useEffect(()=>{
  fetchOrderData({orderStartDate:orderData.startdate})
},[orderData])

  const markAsComplete = async (ids, task) => {
    try {
      // Check if the task is an array or a single task object
      const taskToProcess = Array.isArray(task) ? task[0] : task; // Use the first task if it's an array
  
      if (!taskToProcess) {
        console.error("No task data available");
        return;
      }
  
      // Extract data from the task (using taskToProcess to ensure consistency)
      const fullName = `${firstName} ${lastName}`;
      const payload = {
        ids: ids,
        status: taskToProcess.status,
        notes: taskToProcess.notes,
        orderdate: dayjs(taskToProcess.ts).format('YYYY-MM-DD'),
        login_user: user,
        ordertype: taskToProcess.ordertype,
        username: fullName
      };
  
      // Make API call to mark as complete
      const response = await api.put(`/v1/${practiseid}/tasks/${taskToProcess.patientid}/mark_as_complete`, payload);
  if(response.status==200){
        setToastSeverity('success')
  setToastMessage('Order Completed successfully');
        setOpenToast(true)
        setSelectedTasks([])
          fetchOrderData({orderStartDate:orderData.startdate})
      }else{
           setToastSeverity('info')
        setToastMessage(response.message)
        setOpenToast(true)
      }
    } catch (error) {
            setToastSeverity('error')
        setToastMessage('Something Went Wrong')
        setOpenToast(true)
      console.error("Error marking task as complete:", error);
    }
  };
  
  const markAscancel = async (ids, task) => {
    try {
      // Check if the task is an array or a single task object
      const taskToProcess = Array.isArray(task) ? task[0] : task; // Use the first task if it's an array
  
      if (!taskToProcess) {
        console.error("No task data available");
        return;
      }
  
      // Construct the payload for the cancel action
      const payload = {
        "ids": ids,  // Pass the task ids (task.id or array of ids)
        "notes": taskToProcess.notes, // Use notes from the task
        "st_date": dayjs(taskToProcess.ts).format('YYYY-MM-DD'), // Format the timestamp
        "login_user": user  // Logged in user info
      };
  
      // Make API call to mark as decline (cancel)
      const response = await api.put(`/v1/${practiseid}/tasks/mark_as_decline`, payload);
  if(response.status==200){
        setToastSeverity('success')
  setToastMessage('Order cancelled successfully');
        setOpenToast(true)
        setSelectedTasks([])
          fetchOrderData({orderStartDate:orderData.startdate})
      }else{
           setToastSeverity('info')
        setToastMessage(response.message)
        setOpenToast(true)
      }
    } catch (error) {
            setToastSeverity('error')
        setToastMessage('Something Went Wrong')
        setOpenToast(true)
      console.error("Error marking task as cancelled:", error);
    }
  };
  


  const handleconfirmScheduleClick = async (order) => {
    try {
         // Create the payload to send the status update
         const newStatusFlag = scheduleStates[order.id] === 't' ? 'f' : 't';  // Toggle status for this specific order
         setScheduleStates(prevState => ({
        ...prevState,
        [order.id]: newStatusFlag  // Update only this specific order's status
      }));

         // Create the payload to send the status update
         const payload = {
           orderid: order.id,
           statusflag: newStatusFlag,
           login_user: user // You can replace with the actual logged-in user
         };
      // Call API to update status flag
      const response = await api.put(`/v1/${practiseid}//tasks/update_status_schedule`, payload);

      if (response.status === 200) {
        // If the update was successful, refresh data if necessary

         fetchOrderData({orderStartDate:orderData.startdate})
        
      } else {
        console.error('Error updating status');
      }
    } catch (error) {
      console.error('Error updating status:', error);
    }
  };



  const handleSaveNote = async (order) => {
    const noteContent = newNote; // Get the updated note content
    try {
      if (order.order_notes) {
        // Update existing note API
        await handleUpdatenoteSubmit(order, noteContent);
      } else {
        // Add new note API
        await handleaddnoteSubmit(order, noteContent);
      }
      order.order_notes = noteContent; // Update the note in the local state
      setEditingNote(null); // Close the editor
    } catch (error) {
      console.error('Error saving note:', error);
    }
  };

  const handleCancelNote = () => {
    setEditingNote(null); 
  };


  const handleTaskSelection = (taskIndex) => {
    const updatedSelectedTasks = [...selectedTasks];
    if (updatedSelectedTasks.includes(taskIndex)) {
      updatedSelectedTasks.splice(updatedSelectedTasks.indexOf(taskIndex), 1);
    } else {
      updatedSelectedTasks.push(taskIndex);
    }
    setSelectedTasks(updatedSelectedTasks);
  };

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedTasks([]); // Deselect all
    } else {
      const allTasks = task.map((order, index) => order.id); // Select all tasks
      setSelectedTasks(allTasks);
    }
    setSelectAll(!selectAll);
  };

  const handleCompleteAllTasks = (task) => {

    
    // Convert each task ID to a string and map over the array
    const selectedTasksAsStrings = selectedTasks.map(task => task.toString());

    // Call markAsComplete with the array of strings
    markAsComplete(selectedTasksAsStrings,task);
    setIsCompleted(true);
};

  
  const handleCancelAllTasks = (task) => {
 // Get the task object by index
      markAscancel(selectedTasks.map(task => task.toString()),task);  // Call markAscancel for each task

  };

  let user=localStorage.getItem('user')


  const handleUpdatenoteSubmit = async (order, noteContent) => {
    try {
      const response = await api.put(`/v1/${practiseid}//tasks/update_task_notes`, {
        orderid: order.id, // Assuming task has an 'id' field, you can adjust if it's named differently
        tasknotes: noteContent,
        loginuser: user, // You may want to get the logged-in user's info dynamically
      });
  
 if(response.status==200){
        setToastSeverity('success')
        setToastMessage(response.message)
        setOpenToast(true)
          fetchOrderData({orderStartDate:orderData.startdate})
      }else{
           setToastSeverity('info')
        setToastMessage(response.message)
        setOpenToast(true)
      }
      console.log('Note added successfully:', response.data);
      // Close modal on successful submission
    } catch (error) {
      console.error('Error adding note:', error);
    }
  };

  const handleaddnoteSubmit = async (order, noteContent) => {

    try {
      const response = await api.put(`/v1/${practiseid}//tasks/update_task_notes`,{
        orderid: order.id, // Assuming task has an 'id' field, you can adjust if it's named differently
        tasknotes: noteContent,
        loginuser: user, // You may want to get the logged-in user's info dynamically
      });
 
 if(response.status==200){
        setToastSeverity('success')
        setToastMessage(response.message)
        setOpenToast(true)
          fetchOrderData({orderStartDate:orderData.startdate})
      }else{
           setToastSeverity('info')
        setToastMessage(response.message)
        setOpenToast(true)
      }
      console.log('Note added successfully:', response.data);
    } catch (error) {
      console.error('Error adding note:', error);
    }
  };

  const handleScheduleClick = (order) => {
    setSelectedOrder(order); // Set the selected order for confirmation
    setScheduleConfirmationOpen(true); // Open the confirmation modal
  };

  useEffect(() => {
    // Update selectAll state based on selectedTasks length
    setSelectAll(selectedTasks.length === task.length);
  }, [selectedTasks, task.length]);

   const allTasksCompletedOrCancelled = task.every(order => order.status === 'COMPLETED' || order.status === 'CANCELLEDTASK');
   
   const closeScheduleConfirmationModal = () => {
    setScheduleConfirmationOpen(false);
    setSelectedOrder(null);
  };

    const SelectDate = new Date(selectedAppointment.startdate);
  const formattedDate = SelectDate.getFullYear() + '-' 
                       + (SelectDate.getMonth() + 1).toString().padStart(2, '0') + '-'
                       + SelectDate.getDate().toString().padStart(2, '0');
const checkoutuser=async()=>{
  try {
    setCheckoutLoading(true)
      // const response = await api.put(`/v1/${practiseid}/appointments/visit-purpose/update`,{
      //   "itemVal": 'Checked Out', // Pass the selected status value
      //   "dtype": 'dtvisit',
      //   "app_id": selectedAppointment.appointmentid,
      //   "cid": selectedAppointment.AID,
      //   "searchdate": formattedDate
      // });
        const appointmentsdata=await api.get(`/v1/${practiseid}/appointments/${selectedAppointment?.patientid}/future`
      //   ,{
      // "scheduledate": dt
      // }
    )
    let tableData=[]
    if(appointmentsdata?.status==200){
 tableData=appointmentsdata?.data
    }

console.log(tableData,'tableda')
const matchingAppointments = tableData.filter(item =>
  item.startdate?.slice(0, 10) === selectedAppointment.startdate?.slice(0, 10)
);
console.log(matchingAppointments,'match')
const app_id = matchingAppointments.map(item => item.appointmentid);
const cid = matchingAppointments.map(item => item.id); // Make sure AID exists
const dtype = Array(app_id.length).fill("dtvisit");

const response = await api.put(`/v1/${practiseid}/appointments/visit-purpose/update`, {
  itemVal:Array(app_id.length).fill("Checked Out") ,
  dtype,
  app_id,
  cid,
  searchdate: formattedDate,
});



      if (response.status === 200) {

        setToastMessage(" Visit Status Updated successfully");
        setToastSeverity('success');
        setOpenToast(true);
         fetchScheduleData(selectedDate);
 setTimeout(() => {
  setIsAptcard(false);
}, 1500);
      } else {
        console.error("Update failed.");
        setToastMessage('Failed to Update Visit Status. Please try again.');
        setToastSeverity('info');
        setOpenToast(true);
      }
    } catch (error) {
      console.error('Error updating status:', error);
      setToastMessage('Something Went Wrong');
      setToastSeverity('error');
      setOpenToast(true);
    }finally{
      setCheckoutLoading(false)
    }
}
 
  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50"
    // Close modal on clicking outside
    >
      <div
        className="bg-white  rounded-lg w-[70%] relative flex flex-column"
        onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside the modal
      >
        <div className="flex px-4 py-3 justify-between w-full flex-col sm:flex-row md:flex-row lg:flex-row items-center border-b">
          <h2 className="text-lg font-semibold">Checkout - Pending Tasks ({task.length}) </h2>
           <button onClick={()=>{
            setScreen(navigateto)
          
          }} className="p-2 rounded-full">
              <CloseIcon  style={{ color: "#C7C7CB" }} />
            </button>
        </div>

        <div className='py-4 px-4 border-b items-start w-full flex-col sm:flex-row md:flex-row lg:flex-row '>
          <div className='flex gap-2 items-center'>
            <input
              type="checkbox"
              className="mr-2 w-4 h-4"
              checked={selectAll}
              onChange={handleSelectAll} 
            />
            <div className='text-sm text-[#4B5563] font-semibold '>Select All Tasks</div>
          </div>
        </div>

        <div className="mb-4 max-h-[350px] w-auto overflow-y-auto" style={{scrollbarWidth:'none'}}>
          {task.map((order, index) => (
            <div key={index} className="m-4 border-2 rounded-[10px] border-gray-200">
              <div className="p-4 flex gap-4 w-full border-b pb-4 items-center last:border-0 justify-between ">
              {order.status === 'COMPLETED' ||order.status === 'CANCELLEDTASK' ? (
    <div className="text-sm text-[#15803D] px-4 py-2 bg-[#DCFCE7] rounded-full">{fullName}</div> // Display patient ID if the task is completed
  ) : (
    <div className='w-[150px]'>
    <input
      type="checkbox"
      className="mr-2 w-4 h-4"
      checked={selectedTasks.includes(order.id)}
      onChange={() => handleTaskSelection(order.id)}
    />
    </div>
  )}
                <div className="flex flex-col gap-3 w-[full]">
                  <div className="flex gap-2">
                    <div className="text-sm font-inter text-[16.4px] text-[black] text-left m-0 w-[240px]">
                      {order.ordername && order.ordername.trim() !== ''
                        ? order.ordername.replace(/<[^>]*>/g, '')  // Remove HTML tags from ordername
                        : `${order.tov} Level - ${order.lov}`}
                    </div>
                  </div>
                  <div className="flex justify-between w-[200px]">
                    <p className="text-xs font-inter text-[#4B4B4B]">Ordered by: {order.provider}</p>
                  </div>
                </div>
               { 
  (order.status !== 'COMPLETED' && order.status !== 'CANCELLEDTASK') && 
    <button 
      onClick={() => handleScheduleClick(order)} 
      className="px-3 py-1 bg-[#FAFAF9] text-[#979797] rounded-full text-sm shadow-md border-[1.5px] border-gray-200 flex items-center space-x-2"
    >
     <span>{( order?.schedule === 't') ? 'Schedule' : 'Today'}</span>
      <KeyboardArrowDownIcon style={{ width: '18px' }} />
    </button>
}

                 
                {/* <div className="px-3 py-2 rounded-full text-xs font-semibold bg-[#F0FDF4] text-[#15803D]">
                  <CheckCircleOutlineIcon style={{ color: '#15803D', width: '15px' }} /> {order.status}
                </div> */}

                <div className="cursor-pointer ml-4 max-w-[300px] flex justify-end w-full">
                  {order.order_notes && editingNote !== index ? (
                    <div className="relative w-full bg-[#EFF6FF] p-2 group">
  <div className='text-xs text-left text-[#2563EB]'> 
    <ChatBubbleOutlineIcon style={{ width: "10px", marginRight: '4px', color: '#2563EB' }} />
    Note
  </div>

  <p className="text-sm px-2 text-left">{order.order_notes}</p>

  <div
    className="absolute top-0 right-0 p-1 cursor-pointer opacity-0 group-hover:opacity-100 transition-opacity"
    onClick={() => handleNoteEdit(index)}
  >
    <EditIcon style={{ color: "#4B4B4B", fontSize: '16px' }} />
  </div>
</div>

                  ) : editingNote === index ? (
                    <div className="w-full flex flex-col bg-gray-60 p-2 rounded">
                      <textarea
                        rows={2}
                        value={newNote}
                        onChange={(e) => setNewNote(e.target.value)}
                        className="w-full border-2 p-2 border-gray-300 rounded-md"
                      />
                      <div className="flex gap-2 justify-end mt-2">
                        <button onClick={handleCancelNote} className="px-2 py-1 text-xs text-[black] rounded-md">
                          Cancel
                        </button>
                        <button onClick={() => handleSaveNote(order)} className="px-2 bg-[black] text-xs text-[white] rounded-md">
                          <SaveIcon style={{width:"14px"}}/> Save
                        </button>
                      </div>
                    </div>
                  ) : !order.notes && (
                    <img
                      src={addpdf}
                      className="w-10 h-10"
                      alt="Add PDF"
                      onClick={() => handleNoteEdit(index)} 
                    />
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>

         <div className="flex items-center gap-3 p-4 justify-end">
          {!allTasksCompletedOrCancelled ? (  <>
          <button
  onClick={() => handleCancelAllTasks(task)}
  disabled={selectedTasks.length === 0}
  className={`p-2 px-4 font-inter rounded border border-gray-300 ${
    selectedTasks.length === 0 ? "opacity-50 cursor-not-allowed" : ""
  }`}
>
  Cancel
</button>

          <button
  onClick={() => handleCompleteAllTasks(task)}
  disabled={selectedTasks.length === 0}
  className={`p-2 px-4 font-semibold rounded border text-white ${
    isCompleted ? "bg-[#E17954]" : "bg-[#E17954]"
  } border-gray-300 ${selectedTasks.length === 0 ? "opacity-50 cursor-not-allowed" : ""}`}
>
  {isCompleted ? "Completed ✔" : "Complete"}
</button>

            </>):<>
           <div
             onClick={(e) => {
               if (checkoutloading) return;          
               e.stopPropagation();          
                         setCheckoutconformation(true)          
            
             }}
             className={`rounded px-3 py-1 flex items-center gap-1 font-inter mx-2 text-[12px] shadow-md truncate ${
               checkoutloading ? "bg-gray-300 text-gray-500 cursor-not-allowed" : "bg-[#DBEAFE] text-[#1D4ED8] cursor-pointer"
             }`}
             style={{ opacity: checkoutloading ? 0.6 : 1 }}
           >
             <img src={checkout} alt="?" className={checkoutloading ? "animate-spin w-4 h-4" : "w-4 h-4"} />
             <div>{"Checkout"}</div>
           </div>
            
            
            
            </>}
          
          </div>
      </div>

      <ToastMessage
                  message={toastMessage}
                  severity={toastSeverity}
                  open={openToast}
                  handleClose={handleToastClose}
                />
                 <ConfirmCheckoutModal
  isOpen={CheckoutConformation}
  onClose={() => setCheckoutconformation(false)}
  onCheckout={() => {
 checkoutuser();
    setCheckoutconformation(false);
  }}
/>
      <ScheduleModal
        open={scheduleConfirmationOpen}
        onClose={closeScheduleConfirmationModal}
        onConfirm={handleconfirmScheduleClick}
        order={selectedOrder}
        />
    </div>
  );
};


export default Checkout;
